import React from "react";

import "./united.m.css";
const UnitedInStrength = () => {
  return (
    <div styleName="uae-block-wrapper">
      {/* Row 1 */}
      <div styleName="uae-block-row-one">
        {/* Col 1 - Heading + Text */}
        <div styleName="uae-block-col-text">
          <h2 styleName="uae-block-heading">UNITED IN STRENGTH</h2>
          <p styleName="uae-block-subtext">We are proud. We are resilient. We are United in Strength.</p>
        </div>
        {/* Col 2 - Hero Image aligned to right */}
        <div styleName="uae-block-col-image">
          <img
            styleName="uae-block-hero-image"
            src={"https://images.assettype.com/gulfnews-uat/2026-03-09/5zs5cyf5/uae-united-logo.svg"}
            alt="United in Strength UAE"
          />
        </div>
      </div>

      {/* Row 2 - Text Block */}
      <div styleName="uae-block-row-two">
        <p styleName="uae-block-body-text">
          The UAE is built on acceptance, diversity, and innovation, with people from around the world proudly calling
          it home. It is a place where families grow, businesses thrive, and communities unite, supported by a
          leadership that keeps the country safe and strong. Since 1978, Gulf News has highlighted what makes the UAE a
          great place to live and visit. Today is no different. We are proud. We are resilient. We are United in
          Strength.
        </p>
      </div>
    </div>
  );
};

export default UnitedInStrength;
